import axios from 'axios'

export default class OrderService {
  static async restoreOrders(orderIds) {
    return axios.post(`${process.env.VUE_APP_EXTERNAL_API_BASEURL}/devops/redrive`, { orderIds })
  }
}
